var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCodeSimple = function SvgIconCodeSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.914 6.747a1 1 0 1 0-1.328-1.494l-6.75 6a1 1 0 0 0 0 1.494l6.75 6a1 1 0 1 0 1.328-1.494L3.005 12zM16.414 5.253a1 1 0 0 0-1.328 1.494L20.995 12l-5.91 5.253a1 1 0 0 0 1.33 1.494l6.75-6a1 1 0 0 0 0-1.494z"
  }))));
};
export default SvgIconCodeSimple;